import React from 'react'
import "./TotalAss.css"
import { Chart } from "react-google-charts";

export const data = [
    ["id", "name", "Age", "Donuts eaten"],
    ["Service charges", "Male", 12, 3500],
    ["Service charges", "Male", 12, 3500],
    ["Spares", "Female", 22, 10000],
    ["AMC", "NonBinary", 22, 7000],
    ["CMC", "Female", 20, 15000],
    ["CMC", "Female", 20, 20000],
];

export const options = {
    legend: "none",
    chartArea: { left: 0, top: 0, right: 0, bottom: 0 },
    pieHole: 0.7,
    enableInteractivity: false,
};

const TotalAss = () => {
    return (
        <div className='card_exp23'>
            <h4 className='exp_h23'>Total Assets</h4>
            <div >
                <Chart
                    className='chart_total'
                    chartType="PieChart"
                    data={data}
                    options={options}
                    chartWrapperParams={{ view: { columns: [0, 3] } }}
                />
            </div>
            <div className='fourtysix'>
                46
            </div>
        </div>
    )
}

export default TotalAss
